import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { SnackbarService } from 'src/app/shared/snackbar.service';
import { SnackbarPannelClass } from 'src/app/shared/snackbar-panel';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotpassword!: FormGroup;
  hide = true;
  isLoading = false;
  emailSent = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.forgotpassword = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    });
  }

  onSubmit(): void {
    if (this.forgotpassword.invalid) return;

    this.isLoading = true;
    const email = this.forgotpassword.get('email')?.value;

    this.authService.forgotPassword(email).subscribe({
      next: () => {
        this.isLoading = false;
        this.emailSent = true;
        this.snackbarService.showSnackbar('Линкот за ресетирање е испратен на вашата е-маил адреса', SnackbarPannelClass.Success);
      },
      error: () => {
        this.isLoading = false;
        this.snackbarService.showSnackbar('Настана грешка. Обидете се повторно.', SnackbarPannelClass.Error);
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}